import { useContext } from 'react'
import { Formik, Form, Field, ErrorMessage } from 'formik'
import * as Yup from 'yup'

import BootstrapFormError from '../../components/BootstrapFormError'

import { LoginModalContext } from '../../Login/context/LoginModalContext'

const CommentSchema = Yup.object().shape({
  comment: Yup.string().required('Required').max(2000),
})

function CommentForm(props) {
  const { openLoginModal } = useContext(LoginModalContext)

  const handleOpenLoginModal = () => {
    if (!App.State.userSignedIn) {
      openLoginModal()
    } else {
      return null
    }
  }

  return (
    <Formik
      initialValues={{ comment: '', base: '' }}
      validationSchema={CommentSchema}
      onSubmit={(values, actions) => {
        actions.setSubmitting(true)

        values.commentable_type = App.State.commentableType
        values.commentable_id = App.State.commentableId

        if (props.parent_id) {
          values.parent_id = props.parent_id
        }

        App.Request.post('/comments.json', values)
          .then((response) => {
            const { data, status } = response

            if (status === 200) {
              actions.resetForm()
              props.commentCreated(data)
            } else if (status === 422) {
              actions.setErrors(data.errors)
            } else {
              actions.setFieldError(
                'base',
                'Ooops. Something went wrong. Please try later or contact support@dyler.com'
              )
            }
          })
          .catch(() => {
            actions.setFieldError(
              'base',
              'Ooops. Something went wrong. Please try later or contact support@dyler.com'
            )
          })
          .finally(() => {
            actions.setSubmitting(false)
          })
      }}
    >
      {({ isSubmitting }) => (
        <Form>
          <div className="mb-3">
            <Field
              onClick={handleOpenLoginModal}
              as="textarea"
              name="comment"
              className="form-control"
              rows={3}
              aria-label="New comment"
              readOnly={!App.State.userSignedIn}
              placeholder={props.placeholder}
              style={{ backgroundColor: '#fff' }}
            />
            <ErrorMessage name="comment" component={BootstrapFormError} />
            <ErrorMessage name="base" component={BootstrapFormError} />
          </div>

          <div className="mb-3">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={isSubmitting || !App.State.userSignedIn}
            >
              {isSubmitting ? 'Commenting...' : 'Comment'}
            </button>
            &nbsp;
            {props.parent_id && (
              <button
                type="button"
                className="btn btn-light"
                onClick={() => props.cancel()}
              >
                Cancel
              </button>
            )}
          </div>
        </Form>
      )}
    </Formik>
  )
}

export default CommentForm
